import React from 'react';

import { Modal } from '@epoch-ui/components/Modal/modal';
import {
  AlertDialog,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogContent,
  AlertDialogFooter
} from '@epoch-ui/components/AlertDialog';
import { Button } from '@epoch-ui/components/Button/button';

interface DiscardConfirmModalProps extends React.ComponentPropsWithoutRef<typeof Modal> {
  onDiscard: () => void;
  onCancel: () => void;
}

export const DiscardConfirmModal: React.FC<DiscardConfirmModalProps> = ({
  onDiscard,
  onCancel,
  ...modalProps
}) => {
  return (
    <AlertDialog {...modalProps}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Discard changes?</AlertDialogTitle>
        </AlertDialogHeader>
        <div>
          <p>Changes will be lost if you leave this page. Stay on the page to keep your changes.</p>
        </div>
        <AlertDialogFooter>
          <Button variant="secondary" className="tw-h-10 tw-rounded-lg tw-p-3" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            className="tw-h-10 tw-rounded-lg tw-p-3"
            onClick={onDiscard}
          >
            Discard
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DiscardConfirmModal;
